import * as React from "react";
import { Row, Col, Input, Icon, Select, Button, notification } from "antd";
import FormControl from "components/Forms/FormControl";
import ValidationUtility from "Core/ValidationUtility";
import MaskedInput from "components/Forms/MaskedInput";
import FormUtility from "Core/FormUtility";
import Form, { FormComponentProps } from "antd/lib/form";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { ICreditCardRegistrationDto, AddressDto, IAddressDto } from "Core/Api/Payment/Api";
import { CreditCardRegistrationFormHandler } from "../CreditCardRegistrationFormHandler";
import CreditCardRegisteredList from "../CreditCardRegisteredList";
import { Route } from "react-router-dom";
import TerritorySelector from "../TerritorySelector";
import NotificationUtility from "Core/NotificationUtility";
import { SubmitButton } from "components/SubmitButton";

export interface Props extends FormComponentProps, RouteComponentProps {
    children?: React.ReactNode,
    regId: number,
    billingAddress: IAddressDto;
    cancelButton(): any;
    updated(): any;
}

export interface State {
    territory: string;
}

class BaseUpdateCreditCardForm extends React.Component<Props, State> {
    creditCardRegistrationFormHandler: CreditCardRegistrationFormHandler;

    constructor(props: Props) {
        super(props)
        this.creditCardRegistrationFormHandler = new CreditCardRegistrationFormHandler(props);
        this.onCancel = this.onCancel.bind(this);
        this.UpdateCard = this.UpdateCard.bind(this);

        this.state = {
            territory: '',
        }
    }

    onCancel() {
        this.props.cancelButton();
    }

    onUpdated = () => {
        this.props.updated();
    }

    componentDidMount() {
        this.setState({})
    }

    setTerritoryName = (territory: string) => {
        this.setState({ territory })
        console.log(this.state.territory)
    }

    UpdateCard(event: React.FormEvent) {
        event.preventDefault();

        this.props.form.validateFieldsAndScroll((error, values: AddressDto) => {
            if (!error) {

                //Set province/territory value outside of JM beacuase the select's tags mode places data in array format
                if (values.province && values.countryCode !== 'JM') {
                    values.province = values.province[0];
                }

                this.creditCardRegistrationFormHandler
                    .UpdateCreditCard(this.props.regId, values)
                    .then(() => {
                        NotificationUtility.success('Card Information Updated',
                            'Registered Card Billing Address has been Updated',
                            10,
                            true
                        );
                        //go back to card list
                        this.onUpdated();
                    })
                    .catch(x => {
                        NotificationUtility.error('Card Update Failed', x.message, 30, true);
                    });
            }
        })
    }


    render() {
        const { getFieldDecorator } = this.props.form;
        const { form } = this.props;
        const { Option } = Select;
        const { billingAddress } = this.props

        return (
            <Row type='flex' justify='center' style={{ alignItems: "center", justifyContent: "center" }}>
                <Col span={23} >
                    <Form onSubmit={this.UpdateCard} layout="vertical">

                        <Row type="flex" align="middle" gutter={10} style={{ alignItems: "center", justifyContent: "center", marginBottom: 10 }}>
                            <Col xs={{ span: 7 }}
                                sm={{ span: 7 }}
                                md={{ span: 8 }}
                                lg={{ span: 8 }}
                                xl={{ span: 8 }}
                                style={{ alignSelf: "center" }}
                            >
                                <h2>Billing Details</h2>
                            </Col>
                        </Row>

                        {/* Card Holder's Name */}
                        <Row type="flex" align="middle" gutter={10}>
                            <Col xs={{ span: 22, }}
                                sm={{ span: 22, }}
                                md={{ span: 22, }}
                                lg={{ span: 8, }}
                                xl={{ span: 8, }}>
                                <FormControl
                                    getFieldDecorator={getFieldDecorator}
                                    rules={[...ValidationUtility.getRequired('Please enter your First Name')]}
                                    name="FirstName"
                                    initialValue={billingAddress.firstName}
                                    style={{ fontWeight: "bold" }}
                                    label="First Name">
                                    <Input
                                        prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                        placeholder="First Name"
                                    />
                                </FormControl>
                            </Col>
                            <Col xs={{ span: 22, }}
                                sm={{ span: 22, }}
                                md={{ span: 22, }}
                                lg={{ span: 8, }}
                                xl={{ span: 8, }}>
                                <FormControl
                                    getFieldDecorator={getFieldDecorator}
                                    name="middleName"
                                    initialValue={billingAddress.middleName}
                                    style={{ fontWeight: "bold" }}
                                    label="Middle Name">
                                    <Input
                                        prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                        placeholder="Middle Name"
                                    />
                                </FormControl>
                            </Col>
                            <Col xs={{ span: 22, }}
                                sm={{ span: 22, }}
                                md={{ span: 22, }}
                                lg={{ span: 8, }}
                                xl={{ span: 8, }}>
                                <FormControl
                                    getFieldDecorator={getFieldDecorator}
                                    rules={[...ValidationUtility.getRequired('Please enter your Last Name')]}
                                    name="lastName"
                                    initialValue={billingAddress.lastName}
                                    style={{ fontWeight: "bold" }}
                                    label="Last Name">
                                    <Input
                                        prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                        placeholder="Last Name"
                                    />
                                </FormControl>
                            </Col>
                        </Row>
                        <Row type="flex" align="middle" gutter={10}>
                            {/* Address Line 1 */}
                            <Col xs={{ span: 22, }}
                                sm={{ span: 22, }}
                                md={{ span: 22, }}
                                lg={{ span: 12, }}
                                xl={{ span: 12, }}>
                                <FormControl
                                    getFieldDecorator={getFieldDecorator}
                                    rules={[...ValidationUtility.getRequired('Please enter Address 1')]}
                                    name="addressLine1"
                                    initialValue={billingAddress.addressLine1}
                                    style={{ fontWeight: "bold" }}
                                    label="Address 1">
                                    <Input
                                        prefix={<Icon type="pushpin" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                        placeholder="Address 1"
                                    />
                                </FormControl>
                            </Col>

                            {/* Address Line 2 */}
                            <Col xs={{ span: 22, }}
                                sm={{ span: 22, }}
                                md={{ span: 22, }}
                                lg={{ span: 12, }}
                                xl={{ span: 12, }}>
                                <FormControl
                                    getFieldDecorator={getFieldDecorator}
                                    name="addressLine2"
                                    initialValue={billingAddress.addressLine2}
                                    style={{ fontWeight: "bold" }}
                                    label="Address 2">
                                    <Input
                                        prefix={<Icon type="pushpin" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                        placeholder="Address 1"
                                    />
                                </FormControl>
                            </Col>
                        </Row>

                        {/* Country */}
                        <Row type="flex" align="middle" gutter={10}>
                            <Col xs={{ span: 22, }}
                                sm={{ span: 22, }}
                                md={{ span: 22, }}
                                lg={{ span: 8, }}
                                xl={{ span: 8, }}>
                                <FormControl
                                    getFieldDecorator={getFieldDecorator}
                                    rules={[...ValidationUtility.getRequired('Please select a Country')]}
                                    name="countryCode"
                                    initialValue={billingAddress.countryCode}
                                    style={{ fontWeight: "bold" }}
                                    label="Country"
                                >
                                    {FormUtility.countrySelector()}
                                </FormControl>
                            </Col>

                            {/* City */}
                            <Col xs={{ span: 22, }}
                                sm={{ span: 22, }}
                                md={{ span: 22, }}
                                lg={{ span: 8, }}
                                xl={{ span: 8, }}>
                                <FormControl
                                    getFieldDecorator={getFieldDecorator}
                                    rules={[...ValidationUtility.getRequired('Please enter a City')]}
                                    name="city"
                                    initialValue={billingAddress.city}
                                    style={{ fontWeight: "bold" }}
                                    label="City">
                                    <Input
                                        prefix={<Icon type="pushpin" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                        placeholder="City"
                                    />
                                </FormControl>
                            </Col>
                            <Col xs={{ span: 22, }}
                                sm={{ span: 22, }}
                                md={{ span: 22, }}
                                lg={{ span: 8, }}
                                xl={{ span: 8, }}>
                                {/* Parish -  STATE(USES STATE) IF USE/CANADA; PARISH(USES PROVINCE) FOR JAMAICA; PROVINCE FOR EVERWHERE ELSE*/}
                                <TerritorySelector
                                    intialValue={billingAddress.province ? billingAddress.province : billingAddress.stateCode ? billingAddress.stateCode : ''}
                                    countryCode={form.getFieldValue('countryCode')}
                                    formDecorator={getFieldDecorator}
                                />
                            </Col>

                        </Row>
                        <Row type="flex" align="middle" gutter={10}>

                            {/* Mobile Number */}
                            <Col xs={{ span: 22, }}
                                sm={{ span: 22, }}
                                md={{ span: 22, }}
                                lg={{ span: 8, }}
                                xl={{ span: 8, }}>
                                <FormControl
                                    getFieldDecorator={getFieldDecorator}
                                    rules={[
                                        ...ValidationUtility.getRequired('Please enter your Telephone Number'),
                                        ...ValidationUtility.getPattern(
                                            /[0-9]{3}-[0-9]{3}-[0-9]{4}/,
                                            'Please enter valid Mobile Number'
                                        ),
                                    ]}
                                    label="Mobile Number"
                                    initialValue={billingAddress.telephone}
                                    style={{ fontWeight: "bold" }}
                                    name="telephone">
                                    <MaskedInput
                                        prefix={<Icon type="phone" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                        mask="999-999-9999"
                                        alwaysShowMask={true}
                                        className="Sumperess"
                                        placeholder="Mobile Number"
                                    />
                                </FormControl>
                            </Col>

                            {/* Zip/Postal Code */}
                            <Col xs={{ span: 22, }}
                                sm={{ span: 22, }}
                                md={{ span: 22, }}
                                lg={{ span: 8, }}
                                xl={{ span: 8, }}>
                                <FormControl
                                    getFieldDecorator={getFieldDecorator}
                                    name="zipOrPostalCode"
                                    initialValue={billingAddress.zipOrPostalCode}
                                    style={{ fontWeight: "bold" }}
                                    label="ZIP/Postal Code">
                                    <Input
                                        prefix={<Icon type="pushpin" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                        placeholder="ZIP/Postal Code"
                                    />
                                </FormControl>
                            </Col>

                        </Row>
                        <Row gutter={10}>
                            <Col
                                xs={{ span: 11, offset: 2 }}
                                sm={{ span: 11, offset: 2 }}
                                md={{ span: 5, offset: 5 }}
                                lg={{ span: 5, offset: 7 }}
                                xl={{ span: 5, offset: 8 }}
                            >
                                <SubmitButton type="primary" htmlType="submit" className="login-form-button" style={{ textAlign: "center" }} loadingStyle={{ marginLeft: "-25px" }}> Update Card</SubmitButton>
                            </Col>
                            <Col
                                xs={{ span: 4, }}
                                sm={{ span: 4, }}
                                md={{ span: 3, offset: 2 }}
                                lg={{ span: 3, offset: 1 }}
                                xl={{ span: 3, offset: 0 }}
                            >
                                <Button onClick={this.onCancel} style={{ backgroundColor: "#FF6232", color: 'white' }} className="login-form-button">
                                    Cancel
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        )
    }
}

const UpdateCreditCardFormWithoutRouter = Form.create<Props>({
    name: 'UpdateUserProfileForm',
})(BaseUpdateCreditCardForm);

const UpdateCreditCardForm = withRouter(UpdateCreditCardFormWithoutRouter);

export default UpdateCreditCardForm;